import { useQuery } from "@tanstack/react-query";

import { queries } from "./factories";

export const useReferralSourcesListQuery = () => {
  return useQuery(queries.list());
};
